export const AppClientId = {
  INDEWAL: 1,
  HARRY_NIJBOER: 2,
  HOOIKAMMER: 3,
  IDW_GMBH: 4,
  AUTOWIENTJES: 6,
  AUTOHUISSALLAND: 7,
  IDWLEASE: 12,
  HILTERMANN: 13,
};
